import {AfterViewInit, Component, Input, ViewChild} from '@angular/core';
import {DataTableDto} from "./dto/data-table.dto";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.scss'
})
export class DataTableComponent<T> implements AfterViewInit {
  @Input() dataTable: DataTableDto<T>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngAfterViewInit() {
    this.dataTable.dataSource.paginator = this.paginator;
    this.dataTable.dataSource.sort = this.sort;
  }
}
